var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', {
    staticClass: "footer__org"
  }, [_vm._v("Olimpíada Cearense de Matemática 2026")]), _c('p', {
    staticClass: "footer__meta"
  }, [_vm._v(" Departamento de Matemática - Universidade Federal do Ceará"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:ocm@mat.ufc.br"
    }
  }, [_vm._v("ocm@mat.ufc.br")])])])]);
}];
export { render, staticRenderFns };